import { useState, useEffect } from "@wordpress/element";
import Icon from "@mui/material/Icon";
import { useSelector, useDispatch } from "react-redux";
import { MemoryRouter } from "react-router-dom";
import {
	subscribeCartItemsChanged,
	unsubscribeCartItemsChanged,
	subscribeClearCart,
	unsubscribeClearCart,
} from "eventBus";
import { sumItemQuantity } from "vino/utils";
import {
	selectCartLineItems,
	fetchCartLineItems,
	clearCart,
} from "store/vino/cartSlice";
import QuickCart from "./QuickCart";
import CartBadge from "./CartBadge";

const CartButton = () => {
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [cartItemCount, setCartItemCount] = useState(0);
	const cartItems = useSelector(selectCartLineItems);

	useEffect(() => {
		subscribeCartItemsChanged((_, data) => {
			setCartItemCount(data.totalItems);
		});

		subscribeClearCart(() => {
			dispatch(clearCart());
		});
		return () => {
			unsubscribeCartItemsChanged();
			unsubscribeClearCart();
		};
	}, []);

	useEffect(() => {
		setCartItemCount(sumItemQuantity(cartItems));
	}, [cartItems]);

	const handleOpen = () => {
		dispatch(fetchCartLineItems());
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<MemoryRouter>
			<Icon
				fontSize="small"
				onClick={handleOpen}
				baseClassName="fas"
				className="fa-solid fa-cart-shopping cursor-pointer"
			>
				{cartItemCount > 0 && <CartBadge>{cartItemCount}</CartBadge>}
			</Icon>
			<QuickCart open={open} onClose={handleClose} />
		</MemoryRouter>
	);
};

export default CartButton;
